import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../Assets/TB_Energy_Logo.webp';

import { FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';
import { MdOutlineEmail } from 'react-icons/md';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'About Us', href: '#about' },
    { label: 'Contact Us', href: '#contact' },
  ];

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      {/* Logo */}
      <a
        href="#"
        className="navbar__logo"
        onClick={closeMenu}
        aria-label="TechB Energy Home"
      >
        <img
          src={logo}
          alt="TechB Energy"
          className="navbar__logo-img"
          fetchPriority="high"
        />
      </a>

      {/* Navigation */}
      <div className={`navbar__links ${menuOpen ? 'open' : ''}`}>
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="navbar__link"
            onClick={closeMenu}
          >
            {link.label}
          </a>
        ))}

        {/* Divider */}
        <span
          className="navbar__social-divider"
          aria-hidden="true"
        />

        {/* Social Icons */}
        <div className="navbar__socials">
          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/company/techb-energy-llp/"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar__social-icon"
            aria-label="TechB Energy LinkedIn"
            title="LinkedIn"
          >
            <FaLinkedinIn />
          </a>

          {/* Email */}
          <a
            href="mailto:info@techbenergy.com"
            className="navbar__social-icon"
            aria-label="Email TechB Energy"
            title="Email"
          >
            <MdOutlineEmail />
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/917492848818"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar__social-icon"
            aria-label="WhatsApp TechB Energy"
            title="WhatsApp"
          >
            <FaWhatsapp />
          </a>
        </div>
      </div>

      {/* Mobile Hamburger */}
      <button
        className={`navbar__hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
        type="button"
      >
        <span />
        <span />
        <span />
      </button>
    </nav>
  );
};

export default Navbar;